export default __webpack_public_path__ + "static/media/logo_cpba.74cfd4d5.png";